import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import BeforeAfterSlider from "./BeforeAfterSlider";
import { useLanguage } from "../context/LanguageContext";

export default function HomeBeforeAfterSection() {
  const { t } = useLanguage();

  return (
    <section
      id="ai-preview-example"
      className="section-padding bg-slate-50 transition-colors dark:bg-[#0b1318]"
      data-testid="home-before-after-section"
    >
      <div className="container-width">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)]">
          <div className="max-w-xl">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#5cb85c]">
              {t("homeBeforeAfter.sectionTag")}
            </p>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-slate-900 transition-colors dark:text-white sm:text-4xl lg:text-5xl">
              {t("homeBeforeAfter.title")}
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-slate-600 transition-colors dark:text-slate-300">
              {t("homeBeforeAfter.description")}
            </p>
          </div>

          <div className="min-w-0">
            <BeforeAfterSlider
              beforeSrc="/images/ai-preview/baignoire-avant-768.webp"
              beforeSrcSet="/images/ai-preview/baignoire-avant-768.webp 768w, /images/ai-preview/baignoire-avant-1280.webp 1280w"
              afterSrc="/images/ai-preview/baignoire-apres-768.webp"
              afterSrcSet="/images/ai-preview/baignoire-apres-768.webp 768w, /images/ai-preview/baignoire-apres-1280.webp 1280w"
              sizes="(max-width: 1023px) 100vw, 54vw"
              alt={t("homeBeforeAfter.sliderAlt")}
              imageFit="cover"
              imagePositionClass="object-[12%_center] sm:object-center"
              showAfterLogo
            />
            <p className="mt-3 text-center text-xs leading-relaxed text-slate-500 dark:text-white/45">
              {t("homeBeforeAfter.disclaimer")}
            </p>
            <div className="mt-5 flex justify-center">
              <Link
                to="/ai-preview"
                className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-[#66C95E] px-6 py-3.5 text-center text-base font-semibold text-white shadow-sm transition hover:bg-[#58B551]"
              >
                <Sparkles size={18} />
                {t("homeBeforeAfter.cta")}
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
